/* eslint-disable react-hooks/exhaustive-deps */
// DocumentViewer.tsx

import React, { useState, useEffect, useRef } from "react";
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonFooter,
    IonButtons,
    IonButton,
    useIonLoading,
    useIonAlert,
    useIonToast,
    IonText,
    IonItem,
    IonLabel,
    IonTextarea,
    IonIcon,
    IonCard,
    IonCardContent,
    IonFab,
    IonFabButton,
} from "@ionic/react";
import {
    fetchPendingDocumentById,
    fetchDocumentByAccessHash,
    signDocument,
    declineDocument,
} from "../services/DocumentServices";
import { getApiUrl, getFileUrl } from "../helpers/DevHelper";
import { useAuth } from "../context/Auth";
import { useHistory } from "react-router-dom";
import { PendingDocumentModel } from "../models/GlobalModels";
import {
    TransformWrapper,
    TransformComponent,
    ReactZoomPanPinchRef,
} from "react-zoom-pan-pinch";
import { Capacitor } from "@capacitor/core";

import {
    checkmarkCircleOutline,
    close,
    closeCircleOutline,
} from "ionicons/icons";
import { MdZoomIn, MdZoomOut } from "react-icons/md";
import "./DocumentViewer.scss";

interface DocumentViewerProps {
    documentId?: string | null;
    eSignHash?: string | null;
    isOpen: boolean;
    onClose: () => void;
    onDocumentAction?: () => void;
}

const PhotosViewerModalWithSwiper: React.FC<DocumentViewerProps> = ({
    documentId,
    eSignHash,
    isOpen,
    onClose,
    onDocumentAction,
}) => {
    const [presentLoading, dismissLoading] = useIonLoading();
    const [presentAlert] = useIonAlert();
    const [presentToast] = useIonToast();
    const [documentData, setDocumentData] =
        useState<PendingDocumentModel | null>(null);
    const { checkAxiosError } = useAuth();
    const [error, setError] = useState<string | null>(null);
    const [pdfFile, setPdfFile] = useState<Blob | null>(null);
    const [isScrolledToEnd, setIsScrolledToEnd] = useState<boolean>(false);
    const history = useHistory();

    // State for decline reason modal
    const [showDeclineModal, setShowDeclineModal] = useState<boolean>(false);
    const [declineReason, setDeclineReason] = useState<string>("");
    const [declineError, setDeclineError] = useState<string>("");

    const [blobUrl, setBlobUrl] = useState<string | null>(null);
    const divRef = useRef<HTMLDivElement>(null);
    const transformRef = useRef(null);
    const contentRef = useRef<any>(null);
    const [loadedImages, setLoadedImages] = useState<number[]>([]);

    const [deviceType, setDeviceType] = useState<
        "desktop" | "mobile_tablet" | null
    >(null);

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();

        if (/mobile|iphone|ipod|android|tablet|ipad/.test(userAgent)) {
            setDeviceType("mobile_tablet");
        } else {
            setDeviceType("desktop");
        }
    }, []);

    useEffect(() => {
        if (isOpen && (documentId || eSignHash)) {
            setIsScrolledToEnd(false); // Reset the scroll state when modal opens
            presentLoading("Betöltés...");
            if (documentId) {
                fetchPendingDocumentById(documentId)
                    .then((res: any) => {
                        if (res.data.error === false) {
                            setDocumentData(res.data.data);
                        } else {
                            presentAlert({
                                header: "Hiba",
                                message: "A dokumentum betöltése nem sikerült.",
                                buttons: ["OK"],
                            });
                            onClose();
                        }
                    })
                    .catch((err: any) => {
                        checkAxiosError(err);
                        presentAlert({
                            header: "Hiba",
                            message: "A dokumentum betöltése nem sikerült.",
                            buttons: ["OK"],
                        });
                        onClose();
                    })
                    .finally(() => {
                        dismissLoading();
                    });
            } else if (eSignHash) {
                fetchDocumentByAccessHash(eSignHash)
                    .then((res: any) => {
                        if (res.data.error === false) {
                            setDocumentData(res.data.data);
                        } else {
                            presentAlert({
                                header: "Hiba",
                                message: "A dokumentum betöltése nem sikerült.",
                                buttons: ["OK"],
                            });
                            onClose();
                        }
                    })
                    .catch((err: any) => {
                        presentAlert({
                            header: "Hiba",
                            message: "A dokumentum betöltése nem sikerült.",
                            buttons: ["OK"],
                        });
                        onClose();
                    })
                    .finally(() => {
                        dismissLoading();
                    });
            }
        } else {
            setDocumentData(null);
            setBlobUrl(null);
            setLoadedImages([]);
        }
    }, [isOpen, documentId, eSignHash]);

    useEffect(() => {
        const fetchPdf = async () => {
            const url = getDocumentUrl();
            if (url) {
                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error(
                            `HTTP error! status: ${response.status}`
                        );
                    }
                    const blob = await response.blob();
                    if (blob.size === 0) {
                        throw new Error("Received empty PDF file.");
                    }
                    setPdfFile(blob);
                    setBlobUrl(window.URL.createObjectURL(blob));
                } catch (error: any) {
                    console.error("Error fetching PDF:", error);
                    setError(
                        `A PDF fájl letöltése nem sikerült: ${error.message}`
                    );
                }
            }
        };

        if (documentData) {
            fetchPdf();
        }
    }, [documentData]);

    useEffect(() => {
        if (
            documentData &&
            !documentData.pages.find((x) => !loadedImages.includes(x.id)) &&
            (((Capacitor.isNativePlatform() ||
                deviceType === "mobile_tablet") &&
                transformRef.current) ||
                (!Capacitor.isNativePlatform() && deviceType === "desktop"))
        ) {
            if (deviceType === "desktop" && !Capacitor.isNativePlatform()) {
                handleDesktopScroll();
            } else {
                if (transformRef.current) {
                    const { instance } = transformRef.current;

                    // Jelenlegi pozíciók kinyerése
                    console.log("state", transformRef.current);
                    // console.log("setTransform", setTransform);
                    // console.log(
                    //     "onPanningStop",
                    //     transformRef.current.instance.onPanningStop
                    // );
                    // const { positionX, positionY, scale } =
                    //     instance.transformState;

                    // Kicsit módosítjuk a függőleges pozíciót, hogy imitáljuk a panninget
                    // setTransform(positionX, positionY - 1, scale, 0);

                    // Kézzel meghívjuk az onPanningStop eseményt, ha szükséges
                    // const fakeEvent = new Event("panning");
                    // transformRef.current.instance.onPanningStop(fakeEvent);
                    handleMobileScroll(
                        instance.contentComponent.parentElement,
                        instance.transformState.positionY
                    );
                }
            }
        }
    }, [loadedImages, transformRef]);

    const getDocumentUrl = () => {
        if (
            documentData &&
            documentData.file &&
            documentData.file.access_hash
        ) {
            return `${getApiUrl()}/v1/files/file/${
                documentData.file.access_hash
            }`;
        }
        return null;
    };

    const handleSignDocument = () => {
        presentLoading("Feldolgozás...");
        signDocument(documentData.e_sign_hash)
            .then((res: any) => {
                if (res.data.error === false) {
                    setDocumentData(res.data.data); // Update documentData with new status
                    presentToast({
                        message: "A dokumentum sikeresen aláírva.",
                        duration: 2000,
                        color: "success",
                    });

                    // Call the onDocumentAction callback if provided
                    if (onDocumentAction) {
                        onDocumentAction();
                    }

                    // If eSignHash is null, present the alert
                    if (!eSignHash) {
                        presentAlert({
                            header: "Elfogadás sikeres",
                            message:
                                'A dokumentum elfogadása megtörtént. Az elektronikusan aláírt példányt a "Dokumentumok" menüpontban lehet letölteni.',
                            buttons: [
                                {
                                    text: "Rendben",
                                    handler: () => {
                                        onClose();
                                        history.push("/my/dashboard");
                                    },
                                },
                            ],
                        });
                    }
                } else {
                    presentAlert({
                        header: "Hiba",
                        message:
                            "A dokumentum aláírása technikai okból jelenleg nem lehetséges. Kérjük próbálja újra később.",
                        buttons: ["OK"],
                    });
                }
            })
            .catch((err: any) => {
                presentAlert({
                    header: "Hiba",
                    message:
                        "A dokumentum aláírása technikai okból jelenleg nem lehetséges. Kérjük próbálja újra később.",
                    buttons: ["OK"],
                });
            })
            .finally(() => {
                dismissLoading();
            });
    };

    const handleDeclineDocument = () => {
        setDeclineReason("");
        setDeclineError("");
        setShowDeclineModal(true);
    };

    const submitDecline = () => {
        const reason = declineReason.trim();
        if (!reason || reason.length < 1 || reason.length > 1000) {
            setDeclineError(
                "Az elutasítás indoka legalább 1 és legfeljebb 1000 karakter lehet."
            );
            return;
        }
        setDeclineError("");
        setShowDeclineModal(false);
        presentLoading("Feldolgozás...");
        declineDocument(documentData.e_sign_hash, reason)
            .then((res: any) => {
                if (res.data.error === false) {
                    setDocumentData(res.data.data); // Update documentData with new status
                    presentToast({
                        message: "A dokumentum sikeresen elutasítva.",
                        duration: 2000,
                        color: "success",
                    });

                    // Call the onDocumentAction callback if provided
                    if (onDocumentAction) {
                        onDocumentAction();
                    }

                    // If eSignHash is null, present the alert
                    if (!eSignHash) {
                        presentAlert({
                            header: "Elutasítás sikeres",
                            message: "A dokumentum elutasítása megtörtént",
                            buttons: [
                                {
                                    text: "Rendben",
                                    handler: () => {
                                        onClose();
                                        history.push("/my/dashboard");
                                    },
                                },
                            ],
                        });
                    }
                } else {
                    presentAlert({
                        header: "Hiba",
                        message:
                            "A dokumentum elutasítása technikai okból jelenleg nem lehetséges. Kérjük próbálja újra később.",
                        buttons: ["OK"],
                    });
                }
            })
            .catch((err: any) => {
                presentAlert({
                    header: "Hiba",
                    message:
                        "A dokumentum elutasítása technikai okból jelenleg nem lehetséges. Kérjük próbálja újra később.",
                    buttons: ["OK"],
                });
            })
            .finally(() => {
                dismissLoading();
            });
    };

    const handleDownload = () => {
        // Todo
        if (pdfFile && (blobUrl ?? "") !== "") {
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = documentData?.title
                ? `${documentData.title}.pdf`
                : "dokumentum.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const renderFooterContent = () => {
        if (documentData?.e_sign_status === "SIGNED") {
            return (
                <IonText color="success">
                    <p style={{ textAlign: "center", margin: "1rem" }}>
                        A dokumentum már elfogadásra került.
                    </p>
                </IonText>
            );
        } else if (documentData?.e_sign_status === "DECLINED") {
            return (
                <IonText color="danger">
                    <p style={{ textAlign: "center", margin: "1rem" }}>
                        A dokumentum elutasítása megtörtént. Kérjük várjon, míg
                        munkatárunk felveszi Önnel a kapcsolatot.
                    </p>
                </IonText>
            );
        } else {
            return (
                <div className="button-container">
                    {!isScrolledToEnd ? (
                        <div
                            style={{
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: "larger",
                                // marginBottom: "16px",
                                color: "var(--ion-color-danger)",
                            }}
                        >
                            Elfogadáshoz kérjük görgessen a dokumentum aljára!
                        </div>
                    ) : (
                        <>
                            <IonButton
                                disabled={!isScrolledToEnd}
                                fill="solid"
                                color="danger"
                                onClick={handleDeclineDocument}
                            >
                                Elutasítás
                            </IonButton>
                            <IonButton
                                disabled={!isScrolledToEnd}
                                fill="solid"
                                color="success"
                                onClick={handleSignDocument}
                            >
                                Elfogadás
                            </IonButton>
                        </>
                    )}
                </div>
            );
        }
    };

    const checkScrollableContentPosition = async (
        divRef: HTMLDivElement,
        posY: number
    ) => {
        console.log("visibleHeight", divRef.clientHeight);
        console.log("contentHeight", divRef.scrollHeight);
        console.log("posY", posY);
        if (!isScrolledToEnd) {
            const div = divRef;
            if (div) {
                const visibleHeight = div.clientHeight; // Látható magasság
                const contentHeight = div.scrollHeight; // Teljes tartalom magassága
                console.log("visibleHeight", visibleHeight);
                console.log("contentHeight", contentHeight);
                console.log("posY", posY);
                const isAtBottom =
                    Math.abs(posY) + visibleHeight >= contentHeight;

                if (isAtBottom) {
                    setIsScrolledToEnd(true);
                }
            }
        }
    };

    const handleMobileScroll = async (divRef: HTMLDivElement, posY: number) => {
        console.log("mobile scroll");
        checkScrollableContentPosition(divRef, posY);

        setTimeout(() => {
            checkScrollableContentPosition(divRef, posY);
        }, 100);
        setTimeout(() => {
            checkScrollableContentPosition(divRef, posY);
        }, 300);
        setTimeout(() => {
            checkScrollableContentPosition(divRef, posY);
        }, 500);
    };

    const handleDesktopScroll = async () => {
        console.log("desktop scroll");
        if (divRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = divRef.current;

            console.log("scrollTop", scrollTop);
            console.log("scrollHeight", scrollHeight);
            console.log("clientHeight", clientHeight);
            if (scrollTop + clientHeight + 10 >= scrollHeight) {
                setIsScrolledToEnd(true);
            }
        }
    };

    const shouldHidePdfContent =
        eSignHash &&
        (documentData?.e_sign_status === "DECLINED" ||
            documentData?.e_sign_status === "SIGNED");

    return (
        <>
            <IonModal
                isOpen={isOpen}
                onDidDismiss={onClose}
                cssClass="document-viewer-modal"
            >
                <IonHeader>
                    <IonToolbar className="multiline-toolbar">
                        <div className="custom-title">
                            {documentData?.title ?? "Dokumentum"}
                        </div>
                        {!eSignHash && (
                            <IonButtons slot="end">
                                <IonButton
                                    onClick={onClose}
                                    size="small"
                                    style={{ margin: "6px 6px 0 0" }}
                                >
                                    <IonIcon src={close} />
                                </IonButton>
                            </IonButtons>
                        )}
                    </IonToolbar>
                </IonHeader>

                <IonContent>
                    {shouldHidePdfContent ? (
                        <div className="status-container">
                            {documentData?.e_sign_status === "SIGNED" && (
                                <IonCard className="status-card">
                                    <IonCardContent className="status-card-content">
                                        <IonIcon
                                            icon={checkmarkCircleOutline}
                                            className="status-icon success"
                                        />
                                        <IonText color="success">
                                            <h2 className="status-message">
                                                A dokumentum elfogadásra került.
                                            </h2>
                                        </IonText>
                                        {pdfFile && (
                                            <IonButton
                                                onClick={handleDownload}
                                                expand="block"
                                                style={{ marginTop: "1rem" }}
                                            >
                                                Dokumentum letöltése
                                            </IonButton>
                                        )}
                                    </IonCardContent>
                                </IonCard>
                            )}
                            {documentData?.e_sign_status === "DECLINED" && (
                                <IonCard className="status-card">
                                    <IonCardContent className="status-card-content">
                                        <IonIcon
                                            icon={closeCircleOutline}
                                            className="status-icon danger"
                                        />
                                        <IonText color="danger">
                                            <h2 className="status-message">
                                                A dokumentum elutasítása
                                                megtörtént. Kérjük várjon, míg
                                                munkatárunk felveszi Önnel a
                                                kapcsolatot.
                                            </h2>
                                        </IonText>
                                    </IonCardContent>
                                </IonCard>
                            )}
                        </div>
                    ) : error ? (
                        <div style={{ padding: "1rem", textAlign: "center" }}>
                            <p>{error}</p>
                            {!eSignHash && (
                                <IonButton onClick={onClose}>Bezárás</IonButton>
                            )}
                        </div>
                    ) : (documentData?.pages ?? []).length > 0 ? (
                        <>
                            <div
                                className={
                                    "gallery-container" +
                                    (!Capacitor.isNativePlatform() &&
                                    deviceType === "desktop"
                                        ? " desktop"
                                        : "")
                                }
                                onScroll={
                                    deviceType === "desktop"
                                        ? () => handleDesktopScroll()
                                        : undefined
                                }
                                ref={divRef}
                            >
                                {Capacitor.isNativePlatform() ||
                                deviceType === "mobile_tablet" ? (
                                    <TransformWrapper
                                        ref={transformRef}
                                        initialScale={1}
                                        minScale={1}
                                        maxScale={3}
                                        wheel={{ disabled: true }}
                                        pinch={{ disabled: true }}
                                        doubleClick={{ disabled: true }}
                                        onPanningStop={(
                                            ref: ReactZoomPanPinchRef,
                                            event: TouchEvent | MouseEvent
                                        ) =>
                                            handleMobileScroll(
                                                ref.instance.wrapperComponent,
                                                ref.state.positionY
                                            )
                                        }
                                    >
                                        {({ zoomIn, zoomOut }) => (
                                            <>
                                                <IonFab
                                                    style={{
                                                        bottom: "50px",
                                                    }}
                                                    vertical="top"
                                                    horizontal="end"
                                                    slot="fixed"
                                                >
                                                    <IonFabButton
                                                        onClick={() =>
                                                            zoomIn(0.2)
                                                        }
                                                        style={{
                                                            marginBottom:
                                                                "20px",
                                                        }}
                                                        size="small"
                                                    >
                                                        <MdZoomIn
                                                            fontSize={"1.7em"}
                                                        />
                                                    </IonFabButton>
                                                    <IonFabButton
                                                        onClick={() =>
                                                            zoomOut(0.2)
                                                        }
                                                        size="small"
                                                    >
                                                        <MdZoomOut
                                                            fontSize={"1.7em"}
                                                        />
                                                    </IonFabButton>
                                                </IonFab>
                                                <TransformComponent>
                                                    <div
                                                        className="images-wrapper"
                                                        ref={contentRef}
                                                    >
                                                        {/* {!isScrolledToEnd && (
                                                            <div
                                                                style={{
                                                                    fontWeight:
                                                                        "bold",
                                                                    textAlign:
                                                                        "center",
                                                                    marginBottom:
                                                                        "16px",
                                                                    paddingRight:
                                                                        "44px",
                                                                    color: "var(--ion-color-danger)",
                                                                }}
                                                            >
                                                                Elfogadáshoz
                                                                kérjük görgessen
                                                                a dokumentum
                                                                aljára!
                                                            </div>
                                                        )} */}
                                                        {documentData.pages.map(
                                                            (file, index) => (
                                                                <div
                                                                    key={index}
                                                                    style={{
                                                                        marginBottom:
                                                                            "16px",
                                                                        textAlign:
                                                                            "center",
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            getFileUrl() +
                                                                            "/" +
                                                                            file.access_hash
                                                                        }
                                                                        alt={`Page ${
                                                                            index +
                                                                            1
                                                                        }`}
                                                                        style={{
                                                                            width: "100%",
                                                                            maxWidth:
                                                                                "1024px",
                                                                            height: "auto",
                                                                            boxShadow:
                                                                                "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                                        }}
                                                                        onLoad={() =>
                                                                            setLoadedImages(
                                                                                (
                                                                                    prevState
                                                                                ) => {
                                                                                    return [
                                                                                        ...prevState,
                                                                                        file.id,
                                                                                    ];
                                                                                }
                                                                            )
                                                                        }
                                                                        className="gallery-image"
                                                                    />
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                </TransformComponent>
                                            </>
                                        )}
                                    </TransformWrapper>
                                ) : (
                                    <div>
                                        {/* {!isScrolledToEnd && (
                                            <div
                                                style={{
                                                    fontWeight: "bold",
                                                    textAlign: "center",
                                                    marginBottom: "16px",
                                                    color: "var(--ion-color-danger)",
                                                }}
                                            >
                                                Elfogadáshoz kérjük görgessen a
                                                dokumentum aljára!
                                            </div>
                                        )} */}
                                        {documentData.pages.map(
                                            (file, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        marginBottom: "16px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            getFileUrl() +
                                                            "/" +
                                                            file.access_hash
                                                        }
                                                        alt={`Page ${
                                                            index + 1
                                                        }`}
                                                        style={{
                                                            width: "100%",
                                                            maxWidth: "1024px",
                                                            height: "auto",
                                                            boxShadow:
                                                                "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                        }}
                                                        className="gallery-image"
                                                        onLoad={() =>
                                                            setLoadedImages(
                                                                (prevState) => {
                                                                    return [
                                                                        ...prevState,
                                                                        file.id,
                                                                    ];
                                                                }
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                            {!shouldHidePdfContent && (
                                <>
                                    {!Capacitor.isNativePlatform() &&
                                        deviceType === "desktop" && (
                                            <div className="desktop-footer">
                                                {renderFooterContent()}
                                            </div>
                                        )}
                                </>
                            )}
                        </>
                    ) : (
                        // </div>
                        <div style={{ padding: "1rem", textAlign: "center" }}>
                            <p>Betöltés...</p>
                        </div>
                    )}
                </IonContent>
                {!shouldHidePdfContent &&
                    (Capacitor.isNativePlatform() ||
                        deviceType === "mobile_tablet") && (
                        <IonFooter>
                            <IonToolbar>{renderFooterContent()}</IonToolbar>
                        </IonFooter>
                    )}
            </IonModal>

            {/* Decline Reason Modal */}
            <IonModal
                isOpen={showDeclineModal}
                onDidDismiss={() => setShowDeclineModal(false)}
                cssClass="full-screen-modal"
            >
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Dokumentum elutasítása</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={() => setShowDeclineModal(false)}
                            >
                                Mégse
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <div style={{ padding: "1rem" }}>
                        <IonItem>
                            <IonLabel position="stacked">
                                Kérjük írja be az elutasítás okát (1-1000
                                karakter)
                            </IonLabel>
                            <IonTextarea
                                value={declineReason}
                                onIonChange={(e) =>
                                    setDeclineReason(e.detail.value!)
                                }
                                maxlength={1000}
                            />
                        </IonItem>
                        {declineError && (
                            <IonText color="danger">
                                <p>{declineError}</p>
                            </IonText>
                        )}
                    </div>
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonButtons>
                            <IonButton
                                onClick={submitDecline}
                                color="danger"
                                fill="solid"
                                style={{ width: "100%" }}
                            >
                                Elutasítás
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonFooter>
            </IonModal>
        </>
    );
};

export default PhotosViewerModalWithSwiper;
